export type FinalTagReplacementMap = Record<string, (innerContent: string) => string>;

export const defaultFinalTagReplacements: FinalTagReplacementMap = {
  'final-assist-user-code': (_innerContent: string) => '',
};

export const replaceFinalTaggedSections = (
  content: string,
  replacements: FinalTagReplacementMap = defaultFinalTagReplacements,
): string => {
  const pattern = /%%%((?:final-assist)[\w-]+)%%%([\s\S]*?)%%%\1%%%/g;

  return content.replace(pattern, (fullMatch, tagName: string, innerContent: string) => {
    const newContent = replacements[tagName]?.(innerContent) ?? null;

    if (newContent === null || newContent === undefined) {
      return fullMatch;
    }

    return newContent;
  });
}; 



